import { Input } from 'antd';
import type { InputProps, InputRef } from 'antd';
import React from 'react';
import style from './style.module.scss';

export interface TextFieldProps extends InputProps {
    // Length past which the app clips or wraps the copy. Purely advisory: the
    // field keeps accepting text past it.
    suggestedLength?: number;
}

export const TextField = React.forwardRef<InputRef, TextFieldProps>(
    ({ suggestedLength, ...inputProps }, ref) => {
        const input = <Input ref={ref} {...inputProps} />;

        if (suggestedLength === undefined) {
            return input;
        }

        return (
            <div className={style.field}>
                {input}
                <span
                    className={`footnote_description ${style.character_count}`}
                >
                    {[...String(inputProps.value ?? '')].length}/
                    {suggestedLength}
                </span>
            </div>
        );
    }
);

TextField.displayName = 'TextField';
